import React, { useContext } from 'react';
import context from '../../context';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { Section } from '../../styled-components';

/* Línea superior como componente */
const TopLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #CCCCCC; /* gris oscuro */
  margin-bottom: 3rem;    /* espacio entre línea y contenido */
`;

const Wrap = styled(Section)`
  background: #f3f3f2;
  color: #2b2b2b;
  min-height: 110vh;      /* altura completa */
  display: flex;
  align-items: flex-start;
  padding-top: 8rem;      /* reemplaza varios <br> superiores */
  padding-bottom: 4rem;   /* aire inferior */
`;

/* Contenedor centrado con 80% de ancho */
const Content = styled.div`
  width: 80%;
  margin: 4rem auto 0;    /* top 4rem (en vez de <br>), centrado */
`;

const RowStyled = styled(Row)`
  --bs-gutter-x: clamp(18px, 3.2vw, 44px);
`;

const H1 = styled.h1`
  font-size: clamp(2.5rem, 5vw, 4rem); /* ≈ 64px en pantallas grandes */
  line-height: 1.1;   /* ⬅️ menos espacio entre líneas */
  font-weight: 400;   /* más delgada */
  letter-spacing: .2px;
  margin: -1rem 0 25rem;  /* subido y con menos aire abajo */
  max-width: 28ch;   /* ancho controlado */
  color: #2b2b2b;

  @media (max-width: 768px) {
    max-width: 100%;
    font-size: clamp(1.8rem, 6vw, 2.6rem); /* más pequeño en móviles */
    line-height: 1.15; /* compacto pero legible en mobile */
    margin: -0.5rem 0 2rem;
  }
`;
const Overline = styled.div`
  display: inline-flex;
  align-items: center;
  gap: .6rem;
  font-size: .95rem;
  letter-spacing: .12em;
  font-weight: 700;
  color: #2b2b2b;
  margin: 6px 0 12px;

  &:before{
    content:'';
    display:inline-block;
    width:12px; height:12px;
    border-left: 6px solid ${p => p.theme.primaryColor};
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
  }
`;

const Body = styled.p`
  margin: 0 0 18px;
  font-size: clamp(1rem, 1.15vw, 1.08rem);
  line-height: 1.65;
  color: #3b3b3b;
`;

const Picture = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  margin-top: clamp(12px, 2.2vw, 20px);
  border-radius: 4px;
  display: block;
`;

export default function AboutIntro() {
  const state = useContext(context);

  const title =
    state?.about?.hero?.title ||
    'Un equipo de profesionales especializados en el sector inmobiliario.';

  const copy =
    (state?.about?.history?.description &&
      state.about.history.description.replace(/<[^>]+>/g, '')) ||
    "Este es un espacio para contar más sobre el negocio: quién está detrás, qué hace y qué ofrece este sitio.";

  const image =
    state?.about?.history?.background ||
    state?.home?.about?.banner?.image ||
    'https://images.unsplash.com/photo-1501183638710-841dd1904471?q=80&w=1600&auto=format&fit=crop';

  return (
    <Wrap>
      <Content>
        <TopLine />
        <RowStyled className="align-items-center gy-4">
          <Col xs={12} md={6}>
            <H1>{title}</H1>
          </Col>
          <Col xs={12} md={6}>
            <Overline>Sobre Las Flores</Overline>
            <Body>{copy}</Body>
            <Picture src={image} alt="Sobre Las Flores" />
          </Col>
        </RowStyled>
      </Content>
    </Wrap>
  );
}